import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { AiOutlineBarcode } from "react-icons/ai";
import * as Yup from 'yup';
import ButtonComponent from '../../components/Button';
import InputComponent from '../../components/Input';
import { useDispatch } from 'react-redux';
import { AddBarCodes, AddFaqs } from '../../store/actions/user-action';


const AddBarCodePage = () => {
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues: {
      quantity: '',
    },
    validationSchema: Yup.object({
      quantity: Yup.string()
        .required('Quantity is required')
    }),
    onSubmit: async(values,formik) => {
     dispatch(AddBarCodes(values.quantity,formik))
    },
  });

  useEffect(() => {
  }, [formik.values]);

  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
      <h3 className="font-medium">Add Bar Codes</h3>
      <p className="text-sm text-[#595858] mt-2">
        In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.
      </p>

      {/* Form starts here */}
      <form className="mt-5 w-2/3 m-auto" onSubmit={formik.handleSubmit}>
        <div className="mb-4">
          <label htmlFor="quantity" className="block text-sm font-medium leading-6 text-gray-900">
            Quantity
          </label>
          <InputComponent
          icon={<AiOutlineBarcode/>}
            type="text"
            name="quantity"
            value={formik.values.quantity} // Controlled input
            placeholder="Enter your Quantity"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.quantity && formik.errors.quantity && (
            <p className="text-red-500 text-sm">{formik.errors.quantity}</p>
          )}
        </div>
        <div className="mt-5 text-right rounded">
          <ButtonComponent text="Add Codes" type="submit" />
        </div>
      </form>
    </div>
  );
};

export default AddBarCodePage;
